import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@app/shared/providers/AuthProvider';
import { Page } from '@app/routes';
import { useAppSelector } from '@app/store/hooks';
import { selectIsAuthenticated } from '@app/store/selectors';

export const GuestOnly = () => {
  const { isLoading } = useAuth();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isLoading) return null;

  if (isAuthenticated) {
    return <Navigate to={Page.HOME} replace />;
  }

  return <Outlet />;
};
